import { useEffect, useState } from 'react';

// The club TV screens were drawn at 1920x1080 and their vertical rhythm is what
// makes them readable across a room, so the HEIGHT is the fixed reference.
// Width is free.
//
// Scaling both axes uniformly would letterbox on any panel that is not exactly
// 16:9, and a board on a TV with black bars down the sides looks broken rather
// than deliberate. Instead the stage is scaled to fill the height and given
// whatever width is left over, which each screen's flexible column absorbs.
// Nothing is stretched or cropped.
export const STAGE_HEIGHT = 1080;

/**
 * Fill the screen edge to edge without distorting anything.
 *
 * `minWidth` is the narrowest the layout still fits at. Below it, a very
 * wide-but-short window letterboxes vertically instead of squeezing.
 *
 * Returns the scale to apply and the stage width in design pixels.
 */
export function useTvStage(minWidth) {
  const [stage, setStage] = useState({ scale: 1, width: 1920 });

  useEffect(() => {
    const fit = () => {
      const vw = window.innerWidth;
      const vh = window.innerHeight;

      let scale = vh / STAGE_HEIGHT;
      let width = vw / scale;

      if (width < minWidth) {
        scale = vw / minWidth;
        width = minWidth;
      }

      setStage({ scale, width });
    };

    fit();
    window.addEventListener('resize', fit);
    // Signage panels report their size late often enough to be worth a second look.
    window.addEventListener('orientationchange', fit);
    return () => {
      window.removeEventListener('resize', fit);
      window.removeEventListener('orientationchange', fit);
    };
  }, [minWidth]);

  return stage;
}
